export const FETCHING_MODELS_MENU = '@@toyota/FETCHING_MODELS_MENU';
export const FETCHED_MODELS_MENU = '@@toyota/FETCHED_MODELS_MENU';
export const FETCH_MODELS_MENU_FAILED = '@@toyota/FETCH_MODELS_MENU_FAILED';

export const FETCHING_MODELS_BY_LINE_MENU = '@@toyota/FETCHING_MODELS_BY_LINE_MENU';
export const FETCHED_MODELS_BY_LINE_MENU = '@@toyota/FETCHED_MODELS_BY_LINE_MENU';
export const FETCH_MODELS_MENU_BY_LINE_FAILED = '@@toyota/FETCH_MODELS_MENU_BY_LINE_FAILED';

export const FETCHING_UPDATE_MODELS_BY_LINE_MENU = '@@toyota/FETCHING_UPDATE_MODELS_BY_LINE_MENU';
export const FETCHED_UPDATE_MODELS_BY_LINE_MENU = '@@toyota/FETCHED_UPDATE_MODELS_BY_LINE_MENU';
export const FETCH_UPDATE_MODELS_MENU_BY_LINE_FAILED = '@@toyota/FETCH_UPDATE_MODELS_MENU_BY_LINE_FAILED';

export const UPDATE_TABLE_INVENTORY = '@@toyota/UPDATE_TABLE_INVENTORY';

export const SET_FILTER_INVENTORY = '@@toyota/SET_FILTER_INVENTORY';

export const SET_EXCEL_DATA_INVENTORY = '@@toyota/SET_EXCEL_DATA_INVENTORY';
export const FETCHING_NOTIFICATION_PRIORIZATION = '@@toyota/FETCHING_NOTIFICATION_PRIORIZATION';
export const FETCHED_NOTIFICATION_PRIORIZATION = '@@toyota/FETCHED_NOTIFICATION_PRIORIZATION';
export const FETCH_NOTIFICATION_PRIORIZATION_FAILED = '@@toyota/FETCH_NOTIFICATION_PRIORIZATION_FAILED';
export const FETCHING_UPDATE_NOTIFICATION_PRIORIZATION = '@@toyota/FETCHING_UPDATE_NOTIFICATION_PRIORIZATION';
export const FETCHED_UPDATE_NOTIFICATION_PRIORIZATION = '@@toyota/FETCHED_UPDATE_NOTIFICATION_PRIORIZATION';
export const FETCH_UPDATE_NOTIFICATION_PRIORIZATION_FAILED = '@@toyota/FETCH_UPDATE_NOTIFICATION_PRIORIZATION_FAILED';
export const FETCHING_TRANSIT_REPORT = '@@toyota/FETCHING_TRANSIT_REPORT';
export const FETCHED_TRANSIT_REPORT = '@@toyota/FETCHED_TRANSIT_REPORT';
export const FETCH_TRANSIT_REPORT_FAILED = '@@toyota/FETCH_TRANSIT_REPORT_FAILED';
